import { Globe, Layers, Wallet, ArrowRight } from "lucide-react";
import FadeIn from "./FadeIn";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [Globe, Layers, Wallet];

export const Advantage = () => {
  const { t } = useLang();

  return (
    <section className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <FadeIn>
          <div className="inline-flex items-center gap-2.5 rounded-full border border-tactical/40 bg-tactical/10 px-4 py-2">
            <span className="h-2 w-2 rounded-full bg-tactical animate-pulse-soft" />
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-tactical">
              {t.advantage.eyebrow}
            </span>
          </div>
          <h2 className="mt-5 max-w-3xl font-display text-2xl font-bold leading-tight text-ink sm:text-3xl lg:text-4xl">
            {t.advantage.title}
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink-muted">
            {t.advantage.sub}
          </p>
        </FadeIn>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {t.advantage.cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <FadeIn key={i} delay={0.06 * i}>
                <div
                  data-testid={`advantage-card-${i}`}
                  className="h-full rounded-2xl border border-white/8 bg-night-2/70 p-8 transition-all duration-300 hover:border-tactical/50 hover:shadow-[0_0_50px_-12px_rgba(255,159,28,0.4)]"
                >
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-tactical/30 bg-tactical/10">
                    <Icon size={20} className="text-tactical" strokeWidth={1.7} />
                  </div>
                  <h3 className="mt-6 font-display text-base font-semibold text-ink sm:text-lg">
                    {card.name}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-muted">{card.desc}</p>
                </div>
              </FadeIn>
            );
          })}
        </div>

        <FadeIn delay={0.1}>
          <a
            href="#register"
            data-testid="advantage-cta"
            className="mt-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-tactical/30 bg-tactical/5 px-6 py-5 transition-all hover:border-tactical/60 hover:bg-tactical/10 sm:px-8"
          >
            <span className="flex items-center gap-3.5">
              <span className="h-2.5 w-2.5 rounded-full bg-tactical animate-pulse-soft" />
              <span className="text-sm font-semibold text-ink sm:text-base">
                {t.advantage.strip}
              </span>
            </span>
            <ArrowRight size={18} className="shrink-0 text-tactical" />
          </a>
        </FadeIn>
      </div>
    </section>
  );
};

export default Advantage;